
// @ts-ignore
import FileViewer from 'react-file-viewer';
import {Dialog, DialogContent} from "@mui/material";
import BaseDialogTitle from "./BaseDialogTitle";

interface DialogPreviewFileProps {
    open: boolean,
    onClose: () => void,
    fileBlob: any,
    fileName: string
}


const DialogPreviewFile = ({open, onClose, fileBlob, fileName}: DialogPreviewFileProps) => {
    const fileUrl: string = window.URL.createObjectURL(new Blob([fileBlob]))
    const parts = fileName.split(".");
    const fileType: string = parts[parts.length - 1]

    return (
        <Dialog open={open}
                onClose={onClose}
                maxWidth='md'
                fullWidth
        >
            <BaseDialogTitle onClose={onClose} title={`Previsualización de ${fileName}`}/>
            <DialogContent>
                <div style={{
                    height: '100vh',
                    overflow: fileType.includes('xlsx') ? 'hidden' : 'auto'
                }}>
                    <FileViewer fileType={fileType} filePath={fileUrl}/>
                </div>
            </DialogContent>
        </Dialog>
    )
}

export default DialogPreviewFile